import React, { Component } from 'react';
import ChatWindow from './ChatWindow/ChatWindow';
import ChatRooms from './ChatRooms/ChatRooms';
import TopDashboard from './TopDashboard/TopDashboard';
import firebase from './firebase';
import './Setup.css';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      loggedIn: false,
      currentRoom: 'Main',
      mobileRooms: false,
    };
  }

  handleChange = e => {
    this.setState({
      username: e.target.value,
    });
  };

  handleSubmit = e => {
    const { username } = this.state;
    e.preventDefault();
    if (/\S/.test(username)) {
      // Check if user with the same name already exists
      firebase
        .database()
        .ref(`/UsersOnline/${username}`)
        .once('value', snapshot => {
          if (snapshot.exists()) {
            alert('This name is taken');
          } else {
            this.setState({
              loggedIn: true,
            });
          }
        });
    } else {
      this.setState({
        username: '',
      });
    }
  };

  toggleMobileRooms = () => {
    this.setState(state => ({
      mobileRooms: !state.mobileRooms,
    }));
  };

  changeRoom = e => {
    e.preventDefault();
    this.setState({
      currentRoom: e.target.name,
      mobileRooms: false,
    });
  };

  changeName = () => {
    this.setState({
      loggedIn: false,
    });
  };

  render() {
    const { username, loggedIn, currentRoom, mobileRooms } = this.state;
    return (
      <div className="App">
        {!loggedIn && (
          <form onSubmit={this.handleSubmit} className="login-form">
            <label className="visuallyhidden" htmlFor="username">
              Your Name:
            </label>
            <input
              className="login-form-input"
              id="username"
              type="text"
              onChange={this.handleChange}
              value={username}
              required
              autoComplete="off"
              placeholder="Enter Your Name"
            />
            <input className="login-form-submit" type="submit" value="Enter" />
          </form>
        )}

        {loggedIn && (
          <div className="mainWindow">
            <TopDashboard
              username={username}
              toggleMobileRooms={this.toggleMobileRooms}
              mobileRooms={mobileRooms}
              changeName={this.changeName}
            />
            <ChatRooms
              changeRoom={this.changeRoom}
              mobileRooms={mobileRooms}
              room={currentRoom}
            />
            <ChatWindow room={currentRoom} username={username} />
          </div>
        )}
      </div>
    );
  }
}

export default App;
